export enum SmartAlertStatus {
  Open = 'open',
  Completed = 'completed'
}
